import {
  AbilityBuilder,
  AbilityTuple,
  createMongoAbility,
  MongoQuery,
  PureAbility,
} from '@casl/ability'
import { createContextualCan } from '@casl/react'
import { User } from '../models/Organization'
import { createContext } from 'react'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../models/AccessControl'

export const AbilityContext = createContext(new PureAbility())
export const Can = createContextualCan(AbilityContext.Consumer)

export type AppAbility = PureAbility<AbilityTuple, MongoQuery>

function defineAbilitiesFor(user: User | undefined) {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(
    createMongoAbility,
  )

  if (user) {
    user.role.AccessPolicy.forEach((policy) => {
      let { resource, action } = policy.attribute
      if (action === AttributeActionNames.FindAll) {
        action = AttributeActionNames.Read
      }

      if (policy.allowed) {
        can(action, resource)
      } else {
        cannot(action, resource)
      }
    })
  }

  if (
    can(AttributeActionNames.Read, AttributeResourceNames.Clients) &&
    can(AttributeActionNames.Read, AttributeResourceNames.Projects) &&
    can(AttributeActionNames.Read, AttributeResourceNames.Files)
  ) {
    can(AttributeActionNames.Read, AttributeResourceNames.MainPage)
  } else {
    cannot(AttributeActionNames.Read, AttributeResourceNames.MainPage)
  }

  return build()
}

export { defineAbilitiesFor }
